import { moduleFactory } from './lib';

import './lib/google-tag-manager';

import './../components/static';

import './lib/scrollOffset';
import './lib/newsletter';
import './lib/contact';

import Toggle from './modules/Toggle';
import Animate from './modules/Animate';
import AnimatedLogo from './modules/AnimatedLogo';
import FooterEasterEgg from './modules/FooterEasterEgg';
import BlogPreview from './modules/BlogPreview';
import CookieConsent from './modules/CookieConsent';
import SafariDoubleTapFix from './modules/SafariDoubleTapFix';
import PartnersAnimation from './modules/PartnersAnimation';
import AnimateOnScroll from './modules/AnimateOnScroll';
import Insights from './modules/Insights';

window.myApp = window.myApp || {};

window.addEventListener('DOMContentLoaded', () => {
  AnimatedLogo();
  FooterEasterEgg();
  BlogPreview();
  SafariDoubleTapFix();

  window.myApp.toggles = moduleFactory(Toggle, '[data-toggle]');
  window.myApp.animations = moduleFactory(Animate, '[data-animate]');

  PartnersAnimation();
  AnimateOnScroll();
  CookieConsent();
  Insights();
});



// WEBPACK FOOTER //
// ./src/scripts/index.js